exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#reschedulingList[data-v-58251128] {\n  overflow-y: scroll;\n}\n#rescheduling-table[data-v-58251128] {\n  width: 100%;\n  margin: auto;\n}\n.rescheduling-item td[data-v-58251128] {\n  padding: 5px;\n}\n.rescheduling-item .accepted[data-v-58251128] {\n  background-color: lightgreen;\n}\n.rescheduling-item .denied[data-v-58251128] {\n  background-color: red;\n}\n.rescheduling-item .pending[data-v-58251128] {\n  background-color: white;\n}\n.rescheduling-item .error[data-v-58251128] {\n  background-color: rgb(0, 0, 0);\n  color: rgb(255, 200, 0);\n  font-weight: bold;\n}\n.itemEven[data-v-58251128] {\n  background-color: #ffffcc;\n}\nthead>tr>th[data-v-58251128] {\n  text-align: center;\n}\ntbody>tr[data-v-58251128]:hover {\n  background-color: #ffcccc\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-58251128","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ManagementPage/ReschedulingList.vue
// module id = 518
// module chunks = 0